"use strict";
exports.__esModule = true;
/**
 * @export
 * @namespace DateRange
 */
var DateRange;
(function (DateRange) {
    /**
     * @export
     * @enum {string}
     */
    var TimeRangeEnum;
    (function (TimeRangeEnum) {
        TimeRangeEnum[TimeRangeEnum["OneHour"] = 'OneHour'] = "OneHour";
        TimeRangeEnum[TimeRangeEnum["TwoHours"] = 'TwoHours'] = "TwoHours";
        TimeRangeEnum[TimeRangeEnum["ThreeHours"] = 'ThreeHours'] = "ThreeHours";
        TimeRangeEnum[TimeRangeEnum["SixHours"] = 'SixHours'] = "SixHours";
        TimeRangeEnum[TimeRangeEnum["TwelveHours"] = 'TwelveHours'] = "TwelveHours";
        TimeRangeEnum[TimeRangeEnum["OneDay"] = 'OneDay'] = "OneDay";
        TimeRangeEnum[TimeRangeEnum["TwoDays"] = 'TwoDays'] = "TwoDays";
        TimeRangeEnum[TimeRangeEnum["ThreeDays"] = 'ThreeDays'] = "ThreeDays";
        TimeRangeEnum[TimeRangeEnum["FourDays"] = 'FourDays'] = "FourDays";
        TimeRangeEnum[TimeRangeEnum["FiveDays"] = 'FiveDays'] = "FiveDays";
        TimeRangeEnum[TimeRangeEnum["SixDays"] = 'SixDays'] = "SixDays";
        TimeRangeEnum[TimeRangeEnum["SevenDays"] = 'SevenDays'] = "SevenDays";
    })(TimeRangeEnum = DateRange.TimeRangeEnum || (DateRange.TimeRangeEnum = {}));
})(DateRange = exports.DateRange || (exports.DateRange = {}));
/**
 * @export
 * @namespace Event
 */
var Event;
(function (Event) {
    /**
     * @export
     * @enum {string}
     */
    var EntityTypeEnum;
    (function (EntityTypeEnum) {
        EntityTypeEnum[EntityTypeEnum["Event"] = 'Event'] = "Event";
        EntityTypeEnum[EntityTypeEnum["Market"] = 'Market'] = "Market";
        EntityTypeEnum[EntityTypeEnum["League"] = 'League'] = "League";
        EntityTypeEnum[EntityTypeEnum["Sport"] = 'Sport'] = "Sport";
        EntityTypeEnum[EntityTypeEnum["Region"] = 'Region'] = "Region";
        EntityTypeEnum[EntityTypeEnum["Selection"] = 'Selection'] = "Selection";
    })(EntityTypeEnum = Event.EntityTypeEnum || (Event.EntityTypeEnum = {}));
})(Event = exports.Event || (exports.Event = {}));
/**
 * @export
 * @namespace EventsByLeagueIdRequest
 */
var EventsByLeagueIdRequest;
(function (EventsByLeagueIdRequest) {
    /**
     * @export
     * @enum {string}
     */
    var EventTagsEnum;
    (function (EventTagsEnum) {
        EventTagsEnum[EventTagsEnum["LiveStreaming"] = 'LiveStreaming'] = "LiveStreaming";
        EventTagsEnum[EventTagsEnum["FastMarket"] = 'FastMarket'] = "FastMarket";
        EventTagsEnum[EventTagsEnum["Stats"] = 'Stats'] = "Stats";
    })(EventTagsEnum = EventsByLeagueIdRequest.EventTagsEnum || (EventsByLeagueIdRequest.EventTagsEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventStateEnum;
    (function (EventStateEnum) {
        EventStateEnum[EventStateEnum["Live"] = 'Live'] = "Live";
        EventStateEnum[EventStateEnum["PreLive"] = 'PreLive'] = "PreLive";
        EventStateEnum[EventStateEnum["Mixed"] = 'Mixed'] = "Mixed";
    })(EventStateEnum = EventsByLeagueIdRequest.EventStateEnum || (EventsByLeagueIdRequest.EventStateEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventTypesEnum;
    (function (EventTypesEnum) {
        EventTypesEnum[EventTypesEnum["Fixture"] = 'Fixture'] = "Fixture";
        EventTypesEnum[EventTypesEnum["Outright"] = 'Outright'] = "Outright";
        EventTypesEnum[EventTypesEnum["AntePostRace"] = 'AntePostRace'] = "AntePostRace";
        EventTypesEnum[EventTypesEnum["AggregateFixture"] = 'AggregateFixture'] = "AggregateFixture";
        EventTypesEnum[EventTypesEnum["DayOfEventRace"] = 'DayOfEventRace'] = "DayOfEventRace";
    })(EventTypesEnum = EventsByLeagueIdRequest.EventTypesEnum || (EventsByLeagueIdRequest.EventTypesEnum = {}));
})(EventsByLeagueIdRequest = exports.EventsByLeagueIdRequest || (exports.EventsByLeagueIdRequest = {}));
/**
 * @export
 * @namespace EventsByRegionIdAndSportIdRequest
 */
var EventsByRegionIdAndSportIdRequest;
(function (EventsByRegionIdAndSportIdRequest) {
    /**
     * @export
     * @enum {string}
     */
    var EventTypesEnum;
    (function (EventTypesEnum) {
        EventTypesEnum[EventTypesEnum["Fixture"] = 'Fixture'] = "Fixture";
        EventTypesEnum[EventTypesEnum["Outright"] = 'Outright'] = "Outright";
        EventTypesEnum[EventTypesEnum["AntePostRace"] = 'AntePostRace'] = "AntePostRace";
        EventTypesEnum[EventTypesEnum["AggregateFixture"] = 'AggregateFixture'] = "AggregateFixture";
        EventTypesEnum[EventTypesEnum["DayOfEventRace"] = 'DayOfEventRace'] = "DayOfEventRace";
    })(EventTypesEnum = EventsByRegionIdAndSportIdRequest.EventTypesEnum || (EventsByRegionIdAndSportIdRequest.EventTypesEnum = {}));
})(EventsByRegionIdAndSportIdRequest = exports.EventsByRegionIdAndSportIdRequest || (exports.EventsByRegionIdAndSportIdRequest = {}));
/**
 * @export
 * @namespace EventsBySportIdRequest
 */
var EventsBySportIdRequest;
(function (EventsBySportIdRequest) {
    /**
     * @export
     * @enum {string}
     */
    var EventTagsEnum;
    (function (EventTagsEnum) {
        EventTagsEnum[EventTagsEnum["LiveStreaming"] = 'LiveStreaming'] = "LiveStreaming";
        EventTagsEnum[EventTagsEnum["FastMarket"] = 'FastMarket'] = "FastMarket";
        EventTagsEnum[EventTagsEnum["Stats"] = 'Stats'] = "Stats";
    })(EventTagsEnum = EventsBySportIdRequest.EventTagsEnum || (EventsBySportIdRequest.EventTagsEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventStateEnum;
    (function (EventStateEnum) {
        EventStateEnum[EventStateEnum["Live"] = 'Live'] = "Live";
        EventStateEnum[EventStateEnum["PreLive"] = 'PreLive'] = "PreLive";
        EventStateEnum[EventStateEnum["Mixed"] = 'Mixed'] = "Mixed";
    })(EventStateEnum = EventsBySportIdRequest.EventStateEnum || (EventsBySportIdRequest.EventStateEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventTypesEnum;
    (function (EventTypesEnum) {
        EventTypesEnum[EventTypesEnum["Fixture"] = 'Fixture'] = "Fixture";
        EventTypesEnum[EventTypesEnum["Outright"] = 'Outright'] = "Outright";
        EventTypesEnum[EventTypesEnum["AntePostRace"] = 'AntePostRace'] = "AntePostRace";
        EventTypesEnum[EventTypesEnum["AggregateFixture"] = 'AggregateFixture'] = "AggregateFixture";
        EventTypesEnum[EventTypesEnum["DayOfEventRace"] = 'DayOfEventRace'] = "DayOfEventRace";
    })(EventTypesEnum = EventsBySportIdRequest.EventTypesEnum || (EventsBySportIdRequest.EventTypesEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var LeagueStateEnum;
    (function (LeagueStateEnum) {
        LeagueStateEnum[LeagueStateEnum["Regular"] = 'Regular'] = "Regular";
        LeagueStateEnum[LeagueStateEnum["Mixed"] = 'Mixed'] = "Mixed";
    })(LeagueStateEnum = EventsBySportIdRequest.LeagueStateEnum || (EventsBySportIdRequest.LeagueStateEnum = {}));
})(EventsBySportIdRequest = exports.EventsBySportIdRequest || (exports.EventsBySportIdRequest = {}));
/**
 * @export
 * @namespace EventsCountByTagRequest
 */
var EventsCountByTagRequest;
(function (EventsCountByTagRequest) {
    /**
     * @export
     * @enum {string}
     */
    var EventTagsEnum;
    (function (EventTagsEnum) {
        EventTagsEnum[EventTagsEnum["LiveStreaming"] = 'LiveStreaming'] = "LiveStreaming";
        EventTagsEnum[EventTagsEnum["FastMarket"] = 'FastMarket'] = "FastMarket";
        EventTagsEnum[EventTagsEnum["Stats"] = 'Stats'] = "Stats";
    })(EventTagsEnum = EventsCountByTagRequest.EventTagsEnum || (EventsCountByTagRequest.EventTagsEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventStateEnum;
    (function (EventStateEnum) {
        EventStateEnum[EventStateEnum["Live"] = 'Live'] = "Live";
        EventStateEnum[EventStateEnum["PreLive"] = 'PreLive'] = "PreLive";
        EventStateEnum[EventStateEnum["Mixed"] = 'Mixed'] = "Mixed";
    })(EventStateEnum = EventsCountByTagRequest.EventStateEnum || (EventsCountByTagRequest.EventStateEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventTypesEnum;
    (function (EventTypesEnum) {
        EventTypesEnum[EventTypesEnum["Fixture"] = 'Fixture'] = "Fixture";
        EventTypesEnum[EventTypesEnum["Outright"] = 'Outright'] = "Outright";
        EventTypesEnum[EventTypesEnum["AntePostRace"] = 'AntePostRace'] = "AntePostRace";
        EventTypesEnum[EventTypesEnum["AggregateFixture"] = 'AggregateFixture'] = "AggregateFixture";
        EventTypesEnum[EventTypesEnum["DayOfEventRace"] = 'DayOfEventRace'] = "DayOfEventRace";
    })(EventTypesEnum = EventsCountByTagRequest.EventTypesEnum || (EventsCountByTagRequest.EventTypesEnum = {}));
})(EventsCountByTagRequest = exports.EventsCountByTagRequest || (exports.EventsCountByTagRequest = {}));
/**
 * @export
 * @namespace EventsFromTopLeaguesBySportIdRequest
 */
var EventsFromTopLeaguesBySportIdRequest;
(function (EventsFromTopLeaguesBySportIdRequest) {
    /**
     * @export
     * @enum {string}
     */
    var EventTagsEnum;
    (function (EventTagsEnum) {
        EventTagsEnum[EventTagsEnum["LiveStreaming"] = 'LiveStreaming'] = "LiveStreaming";
        EventTagsEnum[EventTagsEnum["FastMarket"] = 'FastMarket'] = "FastMarket";
        EventTagsEnum[EventTagsEnum["Stats"] = 'Stats'] = "Stats";
    })(EventTagsEnum = EventsFromTopLeaguesBySportIdRequest.EventTagsEnum || (EventsFromTopLeaguesBySportIdRequest.EventTagsEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventStateEnum;
    (function (EventStateEnum) {
        EventStateEnum[EventStateEnum["Live"] = 'Live'] = "Live";
        EventStateEnum[EventStateEnum["PreLive"] = 'PreLive'] = "PreLive";
        EventStateEnum[EventStateEnum["Mixed"] = 'Mixed'] = "Mixed";
    })(EventStateEnum = EventsFromTopLeaguesBySportIdRequest.EventStateEnum || (EventsFromTopLeaguesBySportIdRequest.EventStateEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventTypesEnum;
    (function (EventTypesEnum) {
        EventTypesEnum[EventTypesEnum["Fixture"] = 'Fixture'] = "Fixture";
        EventTypesEnum[EventTypesEnum["Outright"] = 'Outright'] = "Outright";
        EventTypesEnum[EventTypesEnum["AntePostRace"] = 'AntePostRace'] = "AntePostRace";
        EventTypesEnum[EventTypesEnum["AggregateFixture"] = 'AggregateFixture'] = "AggregateFixture";
        EventTypesEnum[EventTypesEnum["DayOfEventRace"] = 'DayOfEventRace'] = "DayOfEventRace";
    })(EventTypesEnum = EventsFromTopLeaguesBySportIdRequest.EventTypesEnum || (EventsFromTopLeaguesBySportIdRequest.EventTypesEnum = {}));
})(EventsFromTopLeaguesBySportIdRequest = exports.EventsFromTopLeaguesBySportIdRequest || (exports.EventsFromTopLeaguesBySportIdRequest = {}));
/**
 * @export
 * @namespace SearchResponse
 */
var SearchResponse;
(function (SearchResponse) {
    /**
     * @export
     * @enum {string}
     */
    var EntityType;
    (function (EntityType) {
        EntityType[EntityType["Event"] = 'Event'] = "Event";
        EntityType[EntityType["League"] = 'League'] = "League";
    })(EntityType = SearchResponse.EntityType || (SearchResponse.EntityType = {}));
})(SearchResponse = exports.SearchResponse || (exports.SearchResponse = {}));
/**
 * @export
 * @namespace League
 */
var League;
(function (League) {
    /**
     * @export
     * @enum {string}
     */
    var EntityTypeEnum;
    (function (EntityTypeEnum) {
        EntityTypeEnum[EntityTypeEnum["Event"] = 'Event'] = "Event";
        EntityTypeEnum[EntityTypeEnum["Market"] = 'Market'] = "Market";
        EntityTypeEnum[EntityTypeEnum["League"] = 'League'] = "League";
        EntityTypeEnum[EntityTypeEnum["Sport"] = 'Sport'] = "Sport";
        EntityTypeEnum[EntityTypeEnum["Region"] = 'Region'] = "Region";
        EntityTypeEnum[EntityTypeEnum["Selection"] = 'Selection'] = "Selection";
    })(EntityTypeEnum = League.EntityTypeEnum || (League.EntityTypeEnum = {}));
})(League = exports.League || (exports.League = {}));
/**
 * @export
 * @namespace Market
 */
var Market;
(function (Market) {
    /**
     * @export
     * @enum {string}
     */
    var EntityTypeEnum;
    (function (EntityTypeEnum) {
        EntityTypeEnum[EntityTypeEnum["Event"] = 'Event'] = "Event";
        EntityTypeEnum[EntityTypeEnum["Market"] = 'Market'] = "Market";
        EntityTypeEnum[EntityTypeEnum["League"] = 'League'] = "League";
        EntityTypeEnum[EntityTypeEnum["Sport"] = 'Sport'] = "Sport";
        EntityTypeEnum[EntityTypeEnum["Region"] = 'Region'] = "Region";
        EntityTypeEnum[EntityTypeEnum["Selection"] = 'Selection'] = "Selection";
    })(EntityTypeEnum = Market.EntityTypeEnum || (Market.EntityTypeEnum = {}));
})(Market = exports.Market || (exports.Market = {}));
/**
 * @export
 * @namespace MarketTypeRequest
 */
var MarketTypeRequest;
(function (MarketTypeRequest) {
    /**
     * @export
     * @enum {string}
     */
    var StatementEnum;
    (function (StatementEnum) {
        StatementEnum[StatementEnum["Include"] = 'Include'] = "Include";
        StatementEnum[StatementEnum["Exclude"] = 'Exclude'] = "Exclude";
    })(StatementEnum = MarketTypeRequest.StatementEnum || (MarketTypeRequest.StatementEnum = {}));
})(MarketTypeRequest = exports.MarketTypeRequest || (exports.MarketTypeRequest = {}));
/**
 * @export
 * @namespace Region
 */
var Region;
(function (Region) {
    /**
     * @export
     * @enum {string}
     */
    var EntityTypeEnum;
    (function (EntityTypeEnum) {
        EntityTypeEnum[EntityTypeEnum["Event"] = 'Event'] = "Event";
        EntityTypeEnum[EntityTypeEnum["Market"] = 'Market'] = "Market";
        EntityTypeEnum[EntityTypeEnum["League"] = 'League'] = "League";
        EntityTypeEnum[EntityTypeEnum["Sport"] = 'Sport'] = "Sport";
        EntityTypeEnum[EntityTypeEnum["Region"] = 'Region'] = "Region";
        EntityTypeEnum[EntityTypeEnum["Selection"] = 'Selection'] = "Selection";
    })(EntityTypeEnum = Region.EntityTypeEnum || (Region.EntityTypeEnum = {}));
})(Region = exports.Region || (exports.Region = {}));
/**
 * @export
 * @namespace Selection
 */
var Selection;
(function (Selection) {
    /**
     * @export
     * @enum {string}
     */
    var EntityTypeEnum;
    (function (EntityTypeEnum) {
        EntityTypeEnum[EntityTypeEnum["Event"] = 'Event'] = "Event";
        EntityTypeEnum[EntityTypeEnum["Market"] = 'Market'] = "Market";
        EntityTypeEnum[EntityTypeEnum["League"] = 'League'] = "League";
        EntityTypeEnum[EntityTypeEnum["Sport"] = 'Sport'] = "Sport";
        EntityTypeEnum[EntityTypeEnum["Region"] = 'Region'] = "Region";
        EntityTypeEnum[EntityTypeEnum["Selection"] = 'Selection'] = "Selection";
    })(EntityTypeEnum = Selection.EntityTypeEnum || (Selection.EntityTypeEnum = {}));
})(Selection = exports.Selection || (exports.Selection = {}));
/**
 * @export
 * @namespace Sport
 */
var Sport;
(function (Sport) {
    /**
     * @export
     * @enum {string}
     */
    var EntityTypeEnum;
    (function (EntityTypeEnum) {
        EntityTypeEnum[EntityTypeEnum["Event"] = 'Event'] = "Event";
        EntityTypeEnum[EntityTypeEnum["Market"] = 'Market'] = "Market";
        EntityTypeEnum[EntityTypeEnum["League"] = 'League'] = "League";
        EntityTypeEnum[EntityTypeEnum["Sport"] = 'Sport'] = "Sport";
        EntityTypeEnum[EntityTypeEnum["Region"] = 'Region'] = "Region";
        EntityTypeEnum[EntityTypeEnum["Selection"] = 'Selection'] = "Selection";
    })(EntityTypeEnum = Sport.EntityTypeEnum || (Sport.EntityTypeEnum = {}));
})(Sport = exports.Sport || (exports.Sport = {}));
/**
 * @export
 * @namespace SportsGroupedByDateRequest
 */
var SportsGroupedByDateRequest;
(function (SportsGroupedByDateRequest) {
    /**
     * @export
     * @enum {string}
     */
    var EventStateEnum;
    (function (EventStateEnum) {
        EventStateEnum[EventStateEnum["Live"] = 'Live'] = "Live";
        EventStateEnum[EventStateEnum["PreLive"] = 'PreLive'] = "PreLive";
        EventStateEnum[EventStateEnum["Mixed"] = 'Mixed'] = "Mixed";
    })(EventStateEnum = SportsGroupedByDateRequest.EventStateEnum || (SportsGroupedByDateRequest.EventStateEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventTypeEnum;
    (function (EventTypeEnum) {
        EventTypeEnum[EventTypeEnum["Fixture"] = 'Fixture'] = "Fixture";
        EventTypeEnum[EventTypeEnum["Outright"] = 'Outright'] = "Outright";
        EventTypeEnum[EventTypeEnum["AntePostRace"] = 'AntePostRace'] = "AntePostRace";
        EventTypeEnum[EventTypeEnum["AggregateFixture"] = 'AggregateFixture'] = "AggregateFixture";
        EventTypeEnum[EventTypeEnum["DayOfEventRace"] = 'DayOfEventRace'] = "DayOfEventRace";
    })(EventTypeEnum = SportsGroupedByDateRequest.EventTypeEnum || (SportsGroupedByDateRequest.EventTypeEnum = {}));
})(SportsGroupedByDateRequest = exports.SportsGroupedByDateRequest || (exports.SportsGroupedByDateRequest = {}));
/**
 * @export
 * @namespace SportsRequest
 */
var SportsRequest;
(function (SportsRequest) {
    /**
     * @export
     * @enum {string}
     */
    var EventStateEnum;
    (function (EventStateEnum) {
        EventStateEnum[EventStateEnum["Live"] = 'Live'] = "Live";
        EventStateEnum[EventStateEnum["PreLive"] = 'PreLive'] = "PreLive";
        EventStateEnum[EventStateEnum["Mixed"] = 'Mixed'] = "Mixed";
    })(EventStateEnum = SportsRequest.EventStateEnum || (SportsRequest.EventStateEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var EventTypeEnum;
    (function (EventTypeEnum) {
        EventTypeEnum[EventTypeEnum["Fixture"] = 'Fixture'] = "Fixture";
        EventTypeEnum[EventTypeEnum["Outright"] = 'Outright'] = "Outright";
        EventTypeEnum[EventTypeEnum["AntePostRace"] = 'AntePostRace'] = "AntePostRace";
        EventTypeEnum[EventTypeEnum["AggregateFixture"] = 'AggregateFixture'] = "AggregateFixture";
        EventTypeEnum[EventTypeEnum["DayOfEventRace"] = 'DayOfEventRace'] = "DayOfEventRace";
    })(EventTypeEnum = SportsRequest.EventTypeEnum || (SportsRequest.EventTypeEnum = {}));
})(SportsRequest = exports.SportsRequest || (exports.SportsRequest = {}));
